// https://www.filestack.com/fileschool/react/react-file-upload/

// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const UploadIntents = () => {

   const [files, set_files] = React.useState(null)
   const [total, set_total] = React.useState(0)
   const [ , set_json] = React.useState();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           {warn}
           <p className="ask-henry-body-margin-bottom-x">Select one or more files:</p>
           <input className="ask-henry-form-input" multiple="multiple" name="file" type="file" onChange={build_on_change} />
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
         </>
      );

   } // build();

   function build_on_change(event) {
      set_files(event.target.files);
      set_total(0);
   } // build_on_change();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;

      if (!files) {
         set_warn('Select at least one file before you submit the form.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }

   } // check();

   const enact = async ({ set_body, set_foot, set_form, set_pass, set_warn, pass, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;
      set_warn('');

      const form_data = new FormData();
      const headers   = { headers: { 'content-type' : 'multipart/form-data' } };

      var file = files[pass - 1];

      form_data.append('file', file);
      form_data.append('fileName', file.name);

      app.set_state('Uploading file ' + file.name);

      var response = await api.fetch('dbs/info/upload/' + app.state.version_id, api.post(form_data), api.token(headers));

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD);
      } else {
         var new_total = total + response.data.number;
         set_total(new_total);
         if (pass < files.length) {
            set_pass(pass + 1);
            app.set_state('status', file.name + ' uploaded');
            var progress = file.name;
            if (30 < progress.length) {
               progress = progress.substr(0, 30) + '. . .';
            }
            set_body(
               <div className="ask-henry-body-margin-bottom-x">
                 <p className="ask-henry-body-margin-bottom-x">{'Processing file ' + progress}</p>
               </div>
            );
            set_foot(<button className="ask-henry-form-button" onClick={form_close} >Cancel</button>);
         } else {
            set_form(FORM.FINAL);
            set_json(response.data);
            set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
         }
         app.set_state('status', pass + ' file(s) uploaded with a ' + new_total + ' response(s).');
      }

   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">A total of {total} responses have been uploaded.</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form build={build} check={check} enact={enact} final={final} title={'Upload Intents' + app.who()} />

} // <UploadIntents />;

export default UploadIntents;
